import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { AuthData } from "../../pages/Auth/reducer";
import { getAuthData } from "../../helpers/localStorageHelpers";
import { HandymanAppState } from "../../configuration/redux/reducers";
import { refreshToken } from "../../pages/Auth/actions";

interface StateFromProps {
    authData?: AuthData;
}

interface DispatchFromProps {
    refreshToken: (refreshToken: string) => any;
}

const AuthProvider = (props: StateFromProps & DispatchFromProps) => {
    const [timeoutId, setTimeoutId] = useState<any>(null);

    useEffect(() => {
        // Initialize by checking and refreshing if needed
        const initializeAuth = () => {
            const authData = getAuthData();

            if (authData) {
                const currentTime = new Date().getTime();
                const tokenExpiryTime = new Date(authData.expires_in).getTime();
                const timeLeft = tokenExpiryTime - currentTime;

                if (timeLeft > 0) {
                    // Schedule the token refresh slightly before expiration
                    scheduleTokenRefresh(authData.refresh_token, timeLeft - 1000);
                } else {
                    // Token has expired; refresh immediately
                    props.refreshToken(authData.refresh_token);
                }
            }
        };

        initializeAuth();
    }, []); // Runs only once on mount

    useEffect(() => {
        // Schedule a new refresh when authData updates
        if (props.authData) {
            const currentTime = new Date().getTime();
            const tokenExpiryTime = currentTime + props.authData.expires_in * 1000;

            // Schedule token refresh slightly before expiration
            scheduleTokenRefresh(props.authData.refresh_token, tokenExpiryTime - currentTime - 1000);
        }

        // Cleanup: Clear the previous timeout
        return () => {
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [props.authData]);

    const scheduleTokenRefresh = (refreshToken: string, delay: number) => {
        const id = setTimeout(() => {
            props.refreshToken(refreshToken);
        }, delay);

        setTimeoutId(id);
    };

    return (props as any).children;
};

const mapStateToProps = (state: HandymanAppState): StateFromProps => ({
    authData: state.user.authData,
});

export default connect<StateFromProps, DispatchFromProps, any, HandymanAppState>(mapStateToProps, {
    refreshToken,
})(AuthProvider);
